import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputBase from "@mui/material/InputBase";
import { useDispatch } from "react-redux";
import { deleteEnterpriseID } from "../../store/UserMaintanence";
import { Close } from "@mui/icons-material";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
  borderRadius: "0px",
}));

function DeleteItem(props) {
  const dispatch = useDispatch();
  const [isUserNameNull, setIsUserNameNull] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);

  const handleClose = () => {
    props.setOpenDelete(false);
  };
  const saveDeleteHandle = () => {
    dispatch(deleteEnterpriseID(props.deleteEntId));
    props.setBoolCheckedDelete(prev => !prev);
    props.setOpenDelete(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.openDelete}
        PaperProps={{ sx: { width: "500px", maxWidth: "500px", borderTop: "2px solid #A100FF" } }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="popup"
          sx={{
            padding: "10px 20px",
            fontSize: "18px",
            fontWeight: "500",
            color: "#000000",
            backgroundColor: "#F1F1EF"
          }}
          onClose={handleClose}
        >
          Delete Entry
        </BootstrapDialogTitle>
        <DialogContent sx={{ padding: "0px !important"}}>
          <Stack sx={{ padding: "10px 20px" }} spacing={2}>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px",fontWeight: "600",color: "#000000", padding: "5px 0px !important" }}>
                Are you sure to delete this Enterprise ID?
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000000", marginTop: "15px !important" }}>
                Enterprise ID <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isUserNameNull && isAddUserOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                value={props.deleteEntId}
                disabled
                sx={{ width: "100%", fontSize: "14px !important", "& .MuiOutlinedInput-root.MuiOutlinedInput-root": {borderRadius: 0, height: 38 } }}
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "10px 20px !important", backgroundColor: "#F1F1EF"}} >
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              backgroundColor: "#F1F1EF",
              border: "1px solid #CFCFCF",
              padding: "5px 30px",
              color: "#000000",
              borderRadius: 0,
              height: "30px",
            }}
            onClick={handleClose}
          >
            Cancel
          </ColorButton>
          <ColorButton
            variant="contained"
            className="save-button"
            size="small"
            sx={{
              backgroundColor: "#000000",
              border: "1px solid #000000",
              padding: "5px 30px",
              color: "#fff",
              borderRadius: 0,
              height: "30px",
              "&:hover": { backgroundColor: "#000000" },
            }}
            onClick={saveDeleteHandle}
          >
            Delete
          </ColorButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default DeleteItem;
